package com.yogaaicoach.common.ui.components

import com.yogaaicoach.pages.auth.TokenDataManager
import react.ChildrenBuilder
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.useState
import web.cssom.ClassName

internal external interface TopBarProps : Props {
    var title: String
    var onSignOut: () -> Unit
    var onNavigateToDashboard: (() -> Unit)?
    var onNavigateToInsights: (() -> Unit)?
    var onNavigateToPayment: (() -> Unit)?
    var onNavigateToContactUs: (() -> Unit)?
}

// Pixel-matched against common/ui/components/layout/TopBar.kt's MenuDropdown — gradient bar
// (primaryBlue -> DarkerBlue), centered title, a menu button opening a dropdown. The real menu
// also has Dashboard/Insights/Subscription/Contact links; this app only has one logged-in page
// so far, so those are console.log stubs here, same as other not-yet-built pages this session.
internal val TopBar = FC<TopBarProps> { props ->
    var menuOpen by useState(false)

    div {
        className = ClassName("top-bar")
        h1 { className = ClassName("top-bar-title"); +props.title }

        div {
            className = ClassName("top-bar-menu")
            button {
                className = ClassName("top-bar-menu-button")
                onClick = { menuOpen = !menuOpen }
                MenuIcon {}
            }

            if (menuOpen) {
                div {
                    className = ClassName("top-bar-dropdown-overlay")
                    onClick = { menuOpen = false }
                }
                div {
                    className = ClassName("top-bar-dropdown")
                    props.onNavigateToDashboard?.let { onDashboard ->
                        DropdownItem(SportsGymnasticsIcon, "Dashboard") {
                            menuOpen = false
                            onDashboard()
                        }
                    }
                    props.onNavigateToInsights?.let { onInsights ->
                        DropdownItem(HistoryIcon, "Insights") {
                            menuOpen = false
                            onInsights()
                        }
                    }
                    div { className = ClassName("top-bar-dropdown-divider") }
                    props.onNavigateToPayment?.let { onPayment ->
                        val isSubscribed = TokenDataManager.tokenData?.isSubscribed == true
                        DropdownItem(CreditCardIcon, if (isSubscribed) "Subscription" else "Upgrade") {
                            menuOpen = false
                            onPayment()
                        }
                    }
                    props.onNavigateToContactUs?.let { onContact ->
                        DropdownItem(ContactEmailIcon, "Contact Us") {
                            menuOpen = false
                            onContact()
                        }
                    }
                    div { className = ClassName("top-bar-dropdown-divider") }
                    DropdownItem(LogoutIcon, "Log out", destructive = true) {
                        menuOpen = false
                        props.onSignOut()
                    }
                }
            }
        }
    }
}

private fun ChildrenBuilder.DropdownItem(
    icon: react.FC<Props>,
    text: String,
    destructive: Boolean = false,
    onSelect: () -> Unit
) {
    button {
        className = ClassName(if (destructive) "top-bar-dropdown-item top-bar-dropdown-item-destructive" else "top-bar-dropdown-item")
        onClick = { onSelect() }
        icon {}
        +text
    }
}
